import { DOMAIN_PORTAL_URL, DOMAIN_GUIDE_URL, domainPortalEnabled } from '../../../shared/domain-portal.mjs';

/** The account Domains tab is the DNS editor. ScalePlus is a link, not a replacement. */
export function createDomainPortalPanel(LegacyDomains) {
  if (!LegacyDomains) return LegacyDomains;
  return {
    name: 'GrooveDomainPortalPanel',
    // Preserve the legacy component's original $parent / $children contract.
    abstract: true,
    components: { LegacyDomains },
    data() {
      return { portalEnabled: domainPortalEnabled() };
    },
    render(h) {
      if (!this.portalEnabled) return h(LegacyDomains);
      return h('section', { attrs: { 'aria-label': 'Domains' } }, [
        h('p', { class: 'px-4 pt-4 mb-2 text-sm' }, [
          'Edit DNS records for your Groove domains here. ',
          h('a', { class: 'underline', attrs: { href: DOMAIN_PORTAL_URL } }, 'Open ScalePlus Domains'),
          ' for connections managed in ScalePlus. ',
          h('a', { class: 'underline', attrs: { href: DOMAIN_GUIDE_URL } }, 'Domain setup guide'),
          '.',
        ]),
        h(LegacyDomains),
      ]);
    },
  };
}
